module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_Student-Testimonial_Er-Hao_Poster-6e8baa0dc9752d31071a994f3733e2d0.jpg";